import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { SERIES_COLORS, sharedAxisProps, sharedTooltipProps } from "./chartTheme";
import { formatNumber } from "./formatters";

// All three series are counts of the same kind, so they share one y-axis. Bounce rate
// and conversions are deliberately left off this chart — plotting a 0–1 rate against
// raw session counts would need a second scale, which misleads more than it shows.
const SERIES = [
  { key: "sessions", label: "Sessions" },
  { key: "users", label: "Users" },
  { key: "pageviews", label: "Pageviews" },
];

const formatTick = (isoDate) => {
  if (!isoDate) return "";
  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) return isoDate;
  return parsed.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const TrafficTrendChart = ({ timeseries = [] }) => {
  if (!timeseries.length) {
    return (
      <div className="bg-surface-container-low rounded-2xl p-10 border border-surface-container-high text-center text-on-surface-variant text-sm">
        No traffic recorded in this period.
      </div>
    );
  }

  return (
    <div className="bg-surface-container-low rounded-2xl p-5 border border-surface-container-high">
      <h3 className="font-headline text-base font-bold mb-2">Traffic Over Time</h3>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={timeseries} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(19,27,46,0.08)" />
          <XAxis dataKey="date" tickFormatter={formatTick} {...sharedAxisProps} minTickGap={24} />
          <YAxis tickFormatter={formatNumber} {...sharedAxisProps} width={48} />
          <Tooltip
            {...sharedTooltipProps}
            labelFormatter={formatTick}
            formatter={(value) => formatNumber(value)}
          />
          <Legend iconType="plainline" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          {SERIES.map(({ key, label }) => (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              name={label}
              stroke={SERIES_COLORS[key]}
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 5, strokeWidth: 2, stroke: "#ffffff" }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrafficTrendChart;
